import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

// TD-23 — başarısız bir okumanın ekrandaki karşılığı. Boş-durum metni ("kayıt yok")
// DEĞİL: sunucudan veri gelmediğinde kullanıcı bunu bilmeli, aksi halde eksik veriye
// bakarak karar veriyor. Sinyal hook'lardan gelir (bkz. utils/apiResult.js).
//
// ApprovalsHubPage'in `status === 'unavailable'` bandıyla aynı dil (uyarı ikonu + tek
// satır metin), ama liste sayfalarının üstüne yerleşecek şekilde yatay.
export default function LoadErrorBanner({ message }) {
  const { t } = useTranslation();
  return (
    <Banner role="alert">
      <AlertTriangle size={16} />
      <span>{message || t('talent.loadFailed')}</span>
    </Banner>
  );
}

const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.auxiliar.danger}14;
  color: ${({ theme }) => theme.colors.auxiliar.danger};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  line-height: 1.4;
`;
